<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout column fill-height>
    <v-flex grow style="width: 100%">
      <v-layout column fill-height v-if="auth.isAuth">
        <v-flex grow style="width: 100%">
        </v-flex>
        <!-- 디테일뷰 -->
        <DetailView/>
        <!-- 관리창 -->
        <ModifView/>
        <v-flex id="map_top_bar" shrink>
          <!-- 테스크탑 바 -->
          <DesktopBar/>
          <!-- 모바일 호환 옵션바 -->
          <MapOptionBar/>
        </v-flex>
        <div class="map-area">
          <v-flex grow id="map_view" class="map-left-view clearfix">
            <!-- 방찾아주세요 배너 -->
            <div class="btn-find-room" v-if="manager.isWaiting" @click="findRoom()">
              <div class="btn-wrap">
                <div class="profile-img">
                  <img :src="`${getStaticUrl()}/logo-profile.svg`" >
                  <!--
                  <img :src="manager.m_profile_img" v-if="manager.m_profile_img !== ''">
                  <div class="no-img" v-if="manager.m_profile_img === ''">
                    <v-icon>camera</v-icon>
                  </div>
                  -->
                </div>
                <div class="profile-info"><span class="point">하우스북</span> 중개사<!--<span class="point-blue">하우스북, 내방좀 찾아줘!{{manager.m_name}}</span> {{manager.m_jobGrade}}님--></div>
                <div class="state"><span>상담원대기</span></div>
                <div class="find-contents-wrap">
                  <div class="msg">
                    방구하려니 궁금한건 많고 막막하시죠?<br>
                    <span class="point">부담없이 친절하게 알려드립니다!</span>
                  </div>
                  <div class="btn-find">
                    <span>알려줘, 하우스북!</span>
                  </div>
                </div>
              </div>
            </div>
            <v-flex class="roadview-area" :style="mapView.roadviewArea?'display:block;':'display:none;'">
              <div class="roadview-btn-line">
                <v-btn class="contents-wrap" dark @click="mapView.roadviewArea = false" >
                  닫기
                </v-btn>
              </div>
              <div id="roadview_area"></div>
            </v-flex>
            <div class="map-btn-line1" column>
              <v-flex>
                <v-menu
                  v-model="mapView.places.popup"
                  :close-on-content-click="false"
                  offset-x
                  nudge-right="5"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn class="contents-wrap" dark v-on="on" >
                      주변
                    </v-btn>
                  </template>

                  <v-card class="pt-1 pb-1">
                    <div class="place-btn-grop" column>
                      <v-flex>
                        <v-btn class="place-btn" small :class="mapView.places.select === 'SC4' ? 'active-btn': ''" @click="setPlaceCategory('SC4')">
                          학교
                        </v-btn>
                      </v-flex>
                      <v-flex>
                        <v-btn class="place-btn" small :class="mapView.places.select === 'CE7' ? 'active-btn': ''" @click="setPlaceCategory('CE7')">
                          카페
                        </v-btn>
                      </v-flex>
                      <v-flex>
                        <v-btn class="place-btn" small :class="mapView.places.select === 'MT1' ? 'active-btn': ''" @click="setPlaceCategory('MT1')">
                          대형마트
                        </v-btn>
                      </v-flex>
                      <v-flex>
                        <v-btn class="place-btn" small :class="mapView.places.select === 'CS2' ? 'active-btn': ''" @click="setPlaceCategory('CS2')">
                          편의점
                        </v-btn>
                      </v-flex>
                      <v-flex>
                        <v-btn class="place-btn" small :class="mapView.places.select === 'PK6' ? 'active-btn': ''" @click="setPlaceCategory('PK6')">
                          주차장
                        </v-btn>
                      </v-flex>
                    </div>
                  </v-card>
                </v-menu>
              </v-flex>
              <v-flex>
                <v-btn class="contents-wrap" :class="mapTypeId === 1 ? 'active-btn': ''" @click="setOverlayMapTypeId(1)" dark>
                  지도
                </v-btn>
              </v-flex>
              <v-flex>
                <v-btn class="contents-wrap" :class="mapTypeId === 6 ? 'active-btn': ''" @click="setOverlayMapTypeId(6)" dark>
                  교통
                </v-btn>
              </v-flex>
              <v-flex>
                <v-btn class="contents-wrap" :class="mapTypeId === 10 ? 'active-btn': ''" @click="setOverlayMapTypeId(10)" dark>
                  지적도
                </v-btn>
              </v-flex>
              <v-flex>
                <v-btn class="contents-wrap" :class="mapTypeId === 2 ? 'active-btn': ''" @click="setOverlayMapTypeId(2)" dark>
                  항공뷰
                </v-btn>
              </v-flex>
              <v-flex>
                <v-btn class="contents-wrap" :class="mapTypeId === 5 ? 'active-btn': ''" @click="setOverlayMapTypeId(5)" dark>
                  거리뷰
                </v-btn>
              </v-flex>
            </div>
            <div class="map-btn-line2">
              <v-flex class="contents-wrap" style="width: auto; max-width: 100%; padding: 0 16px; position: relative; display: inline-block; text-overflow: ellipsis; white-space: nowrap;"><span v-html="mapView.addrMsg"></span></v-flex>
            </div>
            <div class="map-btn-line3" column>
              <v-flex>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn class="contents-wrap-sm" v-on="on" @click="myLoc">
                      <v-icon>my_location</v-icon>
                    </v-btn>
                  </template>
                  <span>현위치</span>
                </v-tooltip>
              </v-flex>
              <v-flex>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-flex class="contents-wrap-sm" style="height: auto;" v-on="on">
                      <v-btn depressed class="contents-btn-clear" @click="zoomIn">
                        <v-icon>add</v-icon>
                      </v-btn>
                      <v-btn depressed class="contents-btn-clear" @click="zoomOut">
                        <v-icon>remove</v-icon>
                      </v-btn>
                    </v-flex>
                  </template>
                  <span>확대축소</span>
                </v-tooltip>
              </v-flex>
              <v-flex class="hidden-sm-and-down">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn class="contents-wrap-sm" v-on="on" :class="mapView.lineDistance.selected ? 'active-btn': ''" @click="btnLineDistance()">
                      <v-icon>straighten</v-icon>
                    </v-btn>
                  </template>
                  <span>거리재기</span>
                </v-tooltip>
              </v-flex>
            </div>
            <!-- 맵 -->
            <kakao-map ref="kakaomap"
                       :appKey="appKey"

                       :center="center"
                       :level="level"
                       :mapTypeId.sync="mapTypeId"
                       :libraries="libraries"

                       @load="onLoad"

                       @center_changed="onMapEvent('center_changed', $event)"
                       @zoom_start="onMapEvent('zoom_start', $event)"
                       @zoom_changed="onMapEvent('zoom_changed', $event)"
                       @bounds_changed="onMapEvent('bounds_changed', $event)"
                       @click="onMapEvent('click', $event)"
                       @dblclick="onMapEvent('dblclick', $event)"
                       @rightclick="onMapEvent('rightclick', $event)"
                       @mousemove="onMapEvent('mousemove', $event)"
                       @dragstart="onMapEvent('dragstart', $event)"
                       @drag="onMapEvent('drag', $event)"
                       @dragend="onMapEvent('dragend', $event)"
                       @idle="onMapEvent('idle', $event)"
                       @tilesloaded="onMapEvent('tilesloaded', $event)"
                       @maptypeid_changed="onMapEvent('maptypeid_changed', $event)"

                       style="position:relative; height: 100%;">
            </kakao-map>
          </v-flex>
          <!-- 매물 리스트 -->
          <map-item-list ref="itemlist"/>
        </div>
      </v-layout>

      <v-layout column fill-height v-if="!auth.isAuth">
        <v-flex grow style="display: flex; justify-content: center; align-items: center;">
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <div style="">
              <svg-logo style="height: 60px;"/>
            </div>
            <div style="font-size: 15px; font-weight: 500; margin: 30px 0 50px 0;">
              사내 서비스 관리 전용 프로그램 입니다.
            </div>
            <div>
              <button
                style="font-size: 18px; font-weight: 600; border: 1px solid #ddd; border-radius: 0.25rem; padding: 10px 40px;"
                @click="auth.modal.login = true"
              >
                로그인
              </button>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import DesktopBar from './layout/DesktopBar'
import MapOptionBar from './layout/map/MapOptionBar'
import MapItemList from './layout/map/MapItemList'
import DetailView from './modal/map/DetailView'
import ModifView from './modal/map/ModifView'
import MapIconSubway from './svg/MapIconSubway'
import KakaoMap from './plugin/KakaoMap'
import EventBus from '@/utile/eventBus'
import Utile from '@/utile/utile'
import SvgLogo from '@/components/svg/Logo'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'PageMap',
  components: {
    DesktopBar,
    MapOptionBar,
    MapItemList,
    DetailView,
    ModifView,
    KakaoMap,
    MapIconSubway,
    SvgLogo
  },
  computed: {
    ...mapState({
      mapData: state => state.mapData,
      auth: state => state.auth,
      manager: state => state.manager,
      config: state => state.config,
      board: state => state.board
    })
  },
  /* 데이터 */
  data: () => ({
    isInit: false,
    appKey: '',
    center: { lat: 37.4803073, lng: 126.9328443 },
    level: 5, // 기본 5
    mapTypeId: KakaoMap.MapTypeId.NORMAL,
    libraries: [ 'services' ],
    mapObject: null,
    geocoder: null,
    mapView: { // 맵 뷰 관리
      updateState: false, // 상태 업데이트 여부
      addrMsg: '', // 행정동 주소정보
      bcode: 0,
      places: {
        popup: false, // 팝업
        select: '', // 선택된 장소 코드
        search: null,
        overlay: null,
        contentNode: null
      },
      roadviewArea: false, // 로드뷰 보여주는 영역
      lineDistance: {
        selected: false,
        drawingFlag: false, // 선이 그려지고 있는 상태를 가지고 있을 변수입니다
        moveLine: null, // 선이 그려지고 있을때 마우스 움직임에 따라 그려질 선 객체 입니다
        clickLine: null, // 마우스로 클릭한 좌표로 그려질 선 객체입니다
        distanceOverlay: null,
        dots: {},
        clickHandler: null,
        mousemoveHandler: null,
        rightclickHandler: null
      },
      overBoundsPolygon: null,
      selectBoundsPolygon: null,
      overBoundsCircle: null,
      selectBoundsCircle: null,
      //
      boundsGeometryPath: {},
      structureMarker: {
        overlay: null,
        contentNode: null
      }
    },
    prevUpdateType: ''
  }),
  created () {
    this.appKey = this.config.kakaRestApiAppKey
    this.level = this.config.mapStartLevel
    this.center.lat = this.config.mapStartPoint.lat
    this.center.lng = this.config.mapStartPoint.lng
  },
  mounted () { // 시작
    // 스크롤해제
    window.scrollTo(0, 0)
    document.getElementsByTagName('html')[0].classList.add('scroll-hidden')
    // 맵 로드
    this.$refs.kakaomap.init()
    // 검색 감시
    let searchTimer = null
    this.$store.watch(() => this.$store.state.mapData.filterState.search, (newValue, oldValue) => {
      if (this.$store.state.mapData.filterState.search !== '') {
        if (searchTimer != null) {
          clearTimeout(searchTimer)
          searchTimer = null
        }
        searchTimer = setTimeout(() => {
          EventBus.$emit('searchAuto', newValue)
        }, 500)
      }
    })

    EventBus.$on('searchAuto', (searchText) => {
      this.requestMapData({'type': 'searchAuto', 'level': this.level, 'bounds': this.mapObject.getBounds(), 'text': searchText}).then(data => {
        if (data.array.length > 0) {
          // console.log('s:', data.array)
          this.mapData.searchAutoView.data = data.array
          this.mapData.searchAutoView.show = true
        }
      })
    })
    /* 반응형 검색 주석
    let searchTimer = null
    this.$store.watch(() => this.$store.state.mapData.filterState.search, (newValue, oldValue) => {
      if (this.$store.state.mapData.filterState.search !== '') {
        if (searchTimer != null) {
          clearTimeout(searchTimer)
          searchTimer = null
        }
        searchTimer = setTimeout(() => {
          this.requestMapData({'type': 'search', 'level': this.level, 'bounds': this.mapObject.getBounds(), 'text': newValue}).then(data => {
            if (data.array.level !== 0 && data.array.center.lat !== 0) {
              // console.log('s:', data)
              try {
                if (this.auth.isStaff || this.auth.isPlusMember) {
                  this.mapObject.setLevel(data.array.level)
                  const _latlng = this.$refs.kakaomap.newLatLng(data.array.center.lat, data.array.center.lng)
                  this.mapObject.setCenter(_latlng)
                  this.updateMap()
                }
                if (data.array.type === 'item') {
                  this.$router.replace({path: 'map', query: { no: 'r' + data.array.no }})
                } else if (data.array.type === 'structure') {
                  this.$router.replace({path: 'map', query: { no: 'b' + data.array.no }})
                }
              } catch (e) {
                //
              }
            } else {
              EventBus.$emit('alert', '검색된 결과가 없습니다.')
            }
          })
        }, 1000)
      }
    })
     */
    // 업데이트 검색 버스
    EventBus.$on('searchMap', () => {
      this.requestMapData({'type': 'search', 'level': this.level, 'bounds': this.mapObject.getBounds(), 'text': this.mapData.filterState.search}).then(data => {
        if (data.array.level !== 0 && data.array.center.lat !== 0) {
          // console.log('s:', data)
          try {
            if (data.array.type === 'item') {
              if (this.auth.isStaff || this.auth.isPlusMember || this.auth.isPartner) {
                this.mapObject.setLevel(data.array.level)
                const _latlng = this.$refs.kakaomap.newLatLng(data.array.center.lat, data.array.center.lng)
                this.mapObject.setCenter(_latlng)
                this.updateMap('search')
              }
              this.$router.replace({path: 'map', query: { no: 'r' + data.array.no }})
            } else if (data.array.type === 'structure') {
              if (this.auth.isStaff || this.auth.isPlusMember || this.auth.isPartner) {
                this.mapObject.setLevel(data.array.level)
                const _latlng = this.$refs.kakaomap.newLatLng(data.array.center.lat, data.array.center.lng)
                this.mapObject.setCenter(_latlng)
                this.updateMap('search')
              }
              this.$router.replace({path: 'map', query: { no: 'b' + data.array.no }})
            } else {
              this.mapObject.setLevel(data.array.level)
              const _latlng = this.$refs.kakaomap.newLatLng(data.array.center.lat, data.array.center.lng)
              this.mapObject.setCenter(_latlng)
              this.updateMap('search')
            }
          } catch (e) {
            //
          }
        } else {
          EventBus.$emit('alert', '검색된 결과가 없습니다.')
        }
      })
    })
    this.$store.watch(() => this.$store.state.mapData.filterState.viewType, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        if (!this.auth.isStaff) { // 직원이 아니라면 위치 초기화
          EventBus.$emit('resetMapPoint')
        } else {
          if (this.mapData.filterState.target.selected) {
            this.requestItemList()
          } else {
            this.updateMap('viewTap')
          }
        }
      }
    })
    // 위치이동
    EventBus.$on('moveCenter', (lat, lng, level) => {
      if (this.mapObject != null) {
        this.mapObject.setCenter(this.$refs.kakaomap.newLatLng(lat, lng))
        this.mapObject.setLevel(level)
      }
    })
    // 부드러운 위치이동
    EventBus.$on('itemListOverMoveCenter', (lat, lng) => {
      if (this.mapObject != null) {
        this.setMapCenter(lat, lng, '', false)
      }
    })
    // 맵 사이즈 제한
    EventBus.$on('resetMapMinLevel', () => {
      if (this.mapObject != null) {
        if (this.auth.isStaff || this.auth.isPlusMember || this.auth.isPartner) {
          this.mapObject.setMinLevel(1)
        } else {
          this.mapObject.setMinLevel(3)
        }
      }
    })
    // 업데이트 리스트 버스
    EventBus.$on('requestItemList', () => {
      this.requestItemList()
    })
    // 업데이트 버스
    EventBus.$on('updateMap', (type = 'null') => {
      this.updateMap(type)
    })
    // 상세뷰 리플레시
    EventBus.$on('reloadDetail', () => {
      // console.log('reloadDetail:', this.$route.query)
      this.routerQuery(this.$route.query)
    })
    // 필터, 맵 포인트 초기화
    EventBus.$on('resetMapState', () => {
      this.$store.dispatch('mapData/filterReset')
      if (this.mapObject != null) {
        this.mapObject.setCenter(this.$refs.kakaomap.newLatLng(this.config.mapStartPoint.lat, this.config.mapStartPoint.lng))
        this.mapObject.setLevel(this.config.mapStartLevel)
        // this.requestItemList()
        this.updateMap('resetMapState')
      }
    })
    // 맵 포인트 초기화
    EventBus.$on('resetMapPoint', () => {
      this.mapObject.setCenter(this.$refs.kakaomap.newLatLng(this.config.mapStartPoint.lat, this.config.mapStartPoint.lng))
      this.mapObject.setLevel(this.config.mapStartLevel)
      // this.requestItemList()
      this.updateMap('resetMapPoint')
    })
    // 전달받은 라우트 쿼리
    this.routerQuery(this.$route.query)
  },
  beforeRouteUpdate (to, from, next) { // 라우터 업데이트
    this.routerQuery(to.query)
    next()
  },
  beforeRouteLeave (to, from, next) {
    this.routerQuery(to.query)
    next()
  },
  destroyed () {
    document.getElementsByTagName('html')[0].classList.remove('scroll-hidden')
  },
  methods: { // 메소드
    ...mapActions({
      requestMapData: 'mapData/requestMapData'
    }),
    findRoom: () => {
      EventBus.$emit('findRoom', 0)
    },
    getMarkerId: (lat, lng) => {
      return Utile.getMarkerId(lat, lng)
    },
    getStaticUrl () {
      return Utile.getStaticUrl()
    },
    /* 라우터 처리 */
    routerQuery (query) {
      // 아이템 상세뷰
      if (query.no) { // 매물 건물 번호가 있을경우
        // console.log('routerQuery:', query)
        if (query.no.toLowerCase().startsWith('r')) { // 매물
          this.mapData.detailView.no = query.no.toLowerCase().replace('r', '')
          this.mapData.detailView.type = 'r'
        } else if (query.no.toLowerCase().startsWith('b')) { // 건물
          this.mapData.detailView.no = query.no.toLowerCase().replace('b', '')
          this.mapData.detailView.type = 'b'
        }
        this.mapData.detailView.show = false
        this.requestMapData({'type': 'detailView', 'no': this.mapData.detailView.no, 'itemType': this.mapData.detailView.type}).then(data => {
          console.log('imgItemArray:', data)
          this.mapData.detailView.show = true
          this.mapData.detailView.data = data.array
          this.mapData.detailView.viewMode = 'all'
          this.mapData.detailView.viewList = []
          this.mapData.detailView.viewList = this.mapData.detailView.viewList.concat(this.mapData.detailView.data.imgVideoArray, this.mapData.detailView.data.imgItemArray, this.mapData.detailView.data.img2dArray, this.mapData.detailView.data.img3dArray)
        })
      } else {
        this.mapData.detailView.show = false
      }
      // 방내놓기
      if (query.receipt) {
        this.board.itemReceipt.show = true
      } else {
        this.board.itemReceipt.show = false
      }
      if (query.request) {
        this.board.requestRoom.show = true
      } else {
        this.board.requestRoom.show = false
      }
      if (query.video) {
        this.board.videoView.tab = query.video.toString()
        this.board.videoView.show = true
      } else {
        this.board.videoView.show = false
      }
    },
    /* 맵 온로드 */
    onLoad (map) {
      // 지도의 현재 영역을 얻어옵니다
      // var bounds = map.getBounds()
      // 영역정보를 문자열로 얻어옵니다. ((남,서), (북,동)) 형식입니다
      // var boundsStr = bounds.toString()
      // console.log('Daum Map Loaded', bounds)
      this.mapObject = map
      this.mapData.mapObject = map
      // 초기셋팅
      this.initMap()
    },
    /* 맵 이벤트 */
    onMapEvent (event, params) {
      // console.log(`Daum Map Event(${event})`, params) // 이벤트 로그
      if (event === 'click') { // 클릭 이벤트
        this.$refs.itemlist.setActiveMap(true)
        if (this.mapTypeId === KakaoMap.MapTypeId.ROADVIEW) { // 로드뷰라면
          var latlng = params[0].latLng
          var roadviewContainer = document.getElementById('roadview_area')
          this.$refs.kakaomap.showRoadView(latlng, roadviewContainer)
          this.mapView.roadviewArea = true
        }
        // 범위 마커 반경 해지
        this.selectBoundsPolygon.setMap(null)
        this.selectBoundsCircle.setMap(null)
        // 범위 마커 타겟팅 해제
        if (this.mapData.filterState.target.selected) {
          this.mapData.filterState.target.selected = false
          this.mapData.itemListOverUpdateCancel = false // 업데이트 캔슬 해지
          this.requestItemList()
        }
        // 건물정보 오버레이 제거
        if (this.level <= 1) {
          this.mapView.structureMarker.overlay.setMap(null)
        }
      }
      if (event === 'zoom_changed') { // 줌 변형
        this.$refs.itemlist.setActiveMap(true)
        this.mapView.updateState = true
        this.center.lat = this.mapObject.getCenter().getLat()
        this.center.lng = this.mapObject.getCenter().getLng()
        // 폴리곤 리셋
        this.mapView.structureMarker.overlay.setMap(null)
        this.selectBoundsPolygon.setMap(null)
        this.selectBoundsCircle.setMap(null)
        // 선택 해제
        this.mapData.filterState.target.selected = false
      } else if (event === 'dragend') { // 맵 드래그
        // this.$refs.itemlist.setActiveMap(true)
        this.center.lat = this.mapObject.getCenter().getLat()
        this.center.lng = this.mapObject.getCenter().getLng()
        // 맵 드래그시 건물 간략정보 오버레이 삭제
        this.mapView.structureMarker.overlay.setMap(null)
        this.updateMap('dragend')
      } else if (event === 'idle') { // 휴식일때 처리
        this.center.lat = this.mapObject.getCenter().getLat()
        this.center.lng = this.mapObject.getCenter().getLng()
        this.level = this.mapObject.getLevel()
        if (this.mapView.updateState) {
          this.updateMap('idle')
        }
        this.mapView.updateState = false
      }
    },
    /* 시구동 출력 */
    loadAddrInfo () {
      var latlng = this.mapObject.getCenter()
      this.$refs.kakaomap.searchAddrFromCoords(latlng, (result, status) => {
        if (status === 'OK') {
          for (var i = 0; i < result.length; i++) {
            // 행정동의 region_type 값은 'H' 이므로
            if (result[i].region_type === 'H') {
              //
            }
            // 법정동
            if (result[i].region_type === 'B') {
              this.mapView.addrMsg = result[i].address_name.replace(/ /gi, '<i class="material-icons" style="color:#ccc; vertical-align: middle; margin-top: -3.5px;" >keyboard_arrow_right</i>')
              this.mapView.bcode = result[i].code
              // 법정동 코드 로드 후 업데이트
              // this.updateMap()
            }
          }
        }
      })
    },
    /* 현위치 버튼 */
    myLoc () {
      let _this = this
      if (navigator.geolocation) { // GPS를 지원하면
        navigator.geolocation.getCurrentPosition(function (position) {
          // alert(position.coords.latitude + ' ' + position.coords.longitude)
          _this.mapObject.setCenter(_this.$refs.kakaomap.newLatLng(position.coords.latitude, position.coords.longitude))
        }, function () {
          EventBus.$emit('alert', '위치정보 사용을 허용 해주시기 바랍니다.')
        })
      } else {
        EventBus.$emit('alert', '위치정보를 제공하지 않는 브라우저 입니다.')
      }
    },
    /* 줌 인아웃 버튼 */
    zoomIn () {
      if (this.level > 1) this.mapObject.setLevel(this.mapObject.getLevel() - 1)
    },
    zoomOut () {
      if (this.level < 9) this.mapObject.setLevel(this.mapObject.getLevel() + 1)
    },
    /* 맵 타입 변경(교통, 지적도 등) */
    setOverlayMapTypeId (maptype) {
      this.$refs.kakaomap.setOverlayMapTypeId(maptype)
    },
    setMapCenter (lat, lng, type, select) {
      this.mapView.updateState = true
      this.$refs.kakaomap.panTo(lat, lng)
    },
    /* 시 */
    requestSIGMarker () {
      if (this.level >= 5 && this.level <= 9) {
        this.requestMapData({'type': 'markerSIG', 'level': this.level, 'bounds': this.mapObject.getBounds()}).then(data => {
          this.$refs.kakaomap.removeCustomOverlay('SIG')
          for (let i = 0; i < data.array.length; i++) {
            // 카운트
            if (this.level >= 6) {
              this.mapData.filterState.totCount += parseInt(data.array[i].itemcount)
            }
            // 마커를 생성하고 지도에 표시합니다
            let content = document.createElement('div')
            content.className = 'map-overlay-sig'
            content.innerHTML = '<div class="info-number">' + data.array[i].itemcount + '</div><div class="info-text">' + data.array[i].addr + '</div>'
            let position = this.$refs.kakaomap.newLatLng(data.array[i].center.lat, data.array[i].center.lng)
            this.$refs.kakaomap.addCustomOverlay('SIG', { // let overlay =
              position: position,
              zIndex: 5,
              clickable: true,
              content: content
            }, content, () => {
              // 지하철 오버레이 클릭
              // this.mapObject.setCenter(position)
              // this.$refs.kakaomap.panTo(data.array[i].center.lat, data.array[i].center.lng)
              this.setMapCenter(data.array[i].center.lat, data.array[i].center.lng, 'SIGMarker', false)
              // this.mapObject.setLevel(5)
              // 리스트 오픈
              this.$refs.itemlist.setActiveMap(false)
            }, () => { // 오버
              // 행정경계 저장
              if (this.mapView.boundsGeometryPath[data.array[i].bcode] === undefined) {
                this.mapView.boundsGeometryPath[data.array[i].bcode] = []
                let pathSet = (a) => {
                  if (Array.isArray(a)) {
                    for (let k = 0; k < a.length; k++) {
                      if (Array.isArray(a[k][0])) {
                        for (let j = 0; j < a[k][0].length; j++) {
                          pathSet(a[k][j])
                        }
                      } else {
                        let lat = 1 * a[k][1]
                        let lng = 1 * a[k][0]
                        if (lat > 0 && lng > 0) {
                          this.mapView.boundsGeometryPath[data.array[i].bcode].push(this.$refs.kakaomap.newLatLng(lat, lng))
                        }
                      }
                    }
                  } else {
                    if (a) {
                      let lat = 1 * a[1]
                      let lng = 1 * a[0]
                      if (lat > 0 && lng > 0) {
                        this.mapView.boundsGeometryPath[data.array[i].bcode].push(this.$refs.kakaomap.newLatLng(lat, lng))
                      }
                    }
                  }
                }
                pathSet(data.array[i].geometry)
              }
              this.overBoundsPolygon.setPath(this.mapView.boundsGeometryPath[data.array[i].bcode])
              this.overBoundsPolygon.setMap(this.mapObject)
            }, () => { // 아웃
              this.overBoundsPolygon.setMap(null)
            })
          }
        })
      } else {
        this.$refs.kakaomap.removeCustomOverlay('SIG')
      }
    },
    /* 동 */
    requestEMDMarker () {
      if (this.level <= 6) {
        this.requestMapData({'type': 'markerEMD', 'level': this.level, 'bounds': this.mapObject.getBounds()}).then(data => {
          this.$refs.kakaomap.removeCustomOverlay('EMD')
          for (let i = 0; i < data.array.length; i++) {
            // 마커를 생성하고 지도에 표시합니다
            let content = document.createElement('div')
            content.className = 'map-overlay-emd'
            content.innerHTML = '<div class="info-number">' + data.array[i].itemcount + '</div><div class="info-text">' + data.array[i].addr + '</div>'
            let position = this.$refs.kakaomap.newLatLng(data.array[i].center.lat, data.array[i].center.lng)
            this.$refs.kakaomap.addCustomOverlay('EMD', { // let overlay =
              position: position,
              zIndex: 4,
              clickable: true,
              content: content
            }, content, () => {
              // 지하철 오버레이 클릭
              // this.mapObject.setCenter(position)
              this.setMapCenter(data.array[i].center.lat, data.array[i].center.lng, 'markerEMD', false)
              // this.mapObject.setLevel(4)
              // 리스트 오픈
              this.$refs.itemlist.setActiveMap(false)
            }, () => { // 오버
              // 행정경계 저장
              if (this.mapView.boundsGeometryPath[data.array[i].bcode] === undefined) {
                this.mapView.boundsGeometryPath[data.array[i].bcode] = []
                let pathSet = (a) => {
                  if (Array.isArray(a)) {
                    for (let k = 0; k < a.length; k++) {
                      if (Array.isArray(a[k][0])) {
                        for (let j = 0; j < a[k][0].length; j++) {
                          pathSet(a[k][j])
                        }
                      } else {
                        let lat = 1 * a[k][1]
                        let lng = 1 * a[k][0]
                        if (lat > 0 && lng > 0) {
                          this.mapView.boundsGeometryPath[data.array[i].bcode].push(this.$refs.kakaomap.newLatLng(lat, lng))
                        }
                      }
                    }
                  } else {
                    if (a) {
                      let lat = 1 * a[1]
                      let lng = 1 * a[0]
                      if (lat > 0 && lng > 0) {
                        this.mapView.boundsGeometryPath[data.array[i].bcode].push(this.$refs.kakaomap.newLatLng(lat, lng))
                      }
                    }
                  }
                }
                pathSet(data.array[i].geometry)
              }
              this.overBoundsPolygon.setPath(this.mapView.boundsGeometryPath[data.array[i].bcode])
              this.overBoundsPolygon.setMap(this.mapObject)
            }, () => { // 아웃
              this.overBoundsPolygon.setMap(null)
            })
          }
        })
      } else {
        this.$refs.kakaomap.removeCustomOverlay('EMD')
      }
    },
    /* 범위 */
    requestRangeMarker () {
      console.log('Bounds: ', this.mapObject.getBounds())
      if (((!this.auth.isStaff && !this.auth.isPlusMember && !this.auth.isPartner) && this.level <= 5) || ((this.auth.isStaff || this.auth.isPlusMember || this.auth.isPartner) && this.level >= 2 && this.level <= 5)) { // 등급별
        this.requestMapData({'type': 'markerRange', 'level': this.level, 'bounds': this.mapObject.getBounds(), 'window': {'w': document.getElementById('map_view').offsetWidth, 'h': document.getElementById('map_view').offsetHeight}}).then(data => {
          this.$refs.kakaomap.removeCustomOverlay('Range')
          for (let i = 0; i < data.array.length; i++) {
            if (data.array[i].itemcount > 0) {
              if (this.level <= 5) {
                this.mapData.filterState.totCount += parseInt(data.array[i].itemcount)
              }
              // 마커를 생성하고 지도에 표시합니다
              let content = document.createElement('div')
              content.className = 'map-overlay-range'
              content.innerHTML = `<div class="info-number ${(this.mapData.itemListOverMarkerId === Utile.getMarkerId(data.array[i].center.lat, data.array[i].center.lng)) ? 'markerAnim' : ''}" id="${Utile.getMarkerId(data.array[i].center.lat, data.array[i].center.lng)}">${data.array[i].itemcount}</div>`
              let position = this.$refs.kakaomap.newLatLng(data.array[i].center.lat, data.array[i].center.lng)
              this.$refs.kakaomap.addCustomOverlay('Range', { // let overlay =
                position: position,
                zIndex: 4,
                clickable: true,
                content: content
              }, content, () => { // 클릭
                let path = []
                if (Array.isArray(data.array[i].path)) {
                  for (let k = 0; k < data.array[i].path.length; k++) {
                    path.push(this.$refs.kakaomap.newLatLng(data.array[i].path[k][0], data.array[i].path[k][1]))
                  }
                  // 마커 리스트 업데이트
                  this.mapData.filterState.target.selected = true
                  this.mapData.filterState.target.type = 'range'
                  // this.mapData.filterState.target.totCount = data.array[i].itemcount
                  this.mapData.filterState.target.totCount = 0
                  this.mapData.filterState.target.listCount = 0
                  this.mapData.filterState.target.minLat = data.array[i].path[0][0]
                  this.mapData.filterState.target.maxLat = data.array[i].path[1][0]
                  this.mapData.filterState.target.minLng = data.array[i].path[1][1]
                  this.mapData.filterState.target.maxLng = data.array[i].path[2][1]

                  if (this.mapData.filterState.target.selected &&
                    (this.mapData.filterState.target.lat !== data.array[i].center.lat ||
                      this.mapData.filterState.target.lng !== data.array[i].center.lng)) {
                    // 중앙 이동
                    this.setMapCenter(data.array[i].center.lat, data.array[i].center.lng, 'markerRange', true)
                  } else {
                    this.requestItemList()
                  }
                  this.mapData.filterState.target.lat = data.array[i].center.lat
                  this.mapData.filterState.target.lng = data.array[i].center.lng
                }
                this.selectBoundsCircle.setMap(null)
                this.overBoundsPolygon.setMap(null)
                this.selectBoundsPolygon.setPath(path)
                this.selectBoundsPolygon.setMap(this.mapObject)

                // 리스트 오픈
                this.$refs.itemlist.setActiveMap(false)
              }, () => { // 오버
                let path = []
                if (Array.isArray(data.array[i].path)) {
                  for (let k = 0; k < data.array[i].path.length; k++) {
                    path.push(this.$refs.kakaomap.newLatLng(data.array[i].path[k][0], data.array[i].path[k][1]))
                  }
                }
                this.overBoundsPolygon.setPath(path)
                this.overBoundsPolygon.setMap(this.mapObject)
              }, () => { // 아웃
                this.overBoundsPolygon.setMap(null)
              })
            }
          }
        })
      } else {
        this.$refs.kakaomap.removeCustomOverlay('Range')
      }
    },
    /* 색상 코드 필터 */
    getStructureTagColor (tag) {
      let code = tag.substr(-2)
      if (code.indexOf('/r') !== -1) {
        return 'color-r'
      } else if (code.indexOf('/o') !== -1) {
        return 'color-o'
      } else if (code.indexOf('/y') !== -1) {
        return 'color-y'
      } else if (code.indexOf('/g') !== -1) {
        return 'color-g'
      } else if (code.indexOf('/b') !== -1) {
        return 'color-b'
      } else if (code.indexOf('/p') !== -1) {
        return 'color-p'
      }
      return ''
    },
    getStructureTagText (tag) {
      let code = tag.substr(-2)
      if (code.indexOf('/') !== -1) {
        tag = tag.replace('/r', '')
        tag = tag.replace('/o', '')
        tag = tag.replace('/y', '')
        tag = tag.replace('/g', '')
        tag = tag.replace('/b', '')
        tag = tag.replace('/p', '')
        return tag
      }
      return tag
    },
    /* 포인트 */
    requestPointMarker () {
      if ((this.auth.isStaff || this.auth.isPlusMember || this.auth.isPartner) && this.level === 1) { // 등급별
        // this.mapView.structureMarker.overlay.setMap(null)
        this.requestMapData({'type': 'markerPoint', 'level': this.level, 'bounds': this.mapObject.getBounds(), 'window': {'w': document.getElementById('map_view').offsetWidth, 'h': document.getElementById('map_view').offsetHeight}}).then(data => {
          this.$refs.kakaomap.removeCustomOverlay('Point')
          for (let i = 0; i < data.array.length; i++) {
            if (data.array[i].match === 1 && this.mapData.filterState.viewType === 'tab-3') {
              this.mapData.filterState.totCount += 1
            } else {
              this.mapData.filterState.totCount += parseInt(data.array[i].itemcount)
            }
            // 마커를 생성하고 지도에 표시합니다
            let content = document.createElement('div')
            content.className = 'map-overlay-point'
            content.innerHTML = `<div class="${((data.array[i].match === 1) ? 'search-match' : '')}"><div class="info-number ${(this.mapData.itemListOverMarkerId === Utile.getMarkerId(data.array[i].lat, data.array[i].lng)) ? 'markerAnim' : ''}" id="${Utile.getMarkerId(data.array[i].lat, data.array[i].lng)}">${data.array[i].itemcount}</div><div class="info-text ${(this.mapData.itemListOverMarkerId === Utile.getMarkerId(data.array[i].lat, data.array[i].lng)) ? 'markerAnimTextBox' : ''}">${((data.array[i].name === '') ? '미지정' : data.array[i].name)}</div></div>`
            let position = this.$refs.kakaomap.newLatLng(data.array[i].lat, data.array[i].lng)
            const overlay = this.$refs.kakaomap.addCustomOverlay('Point', { // let overlay =
              position: position,
              zIndex: 4,
              clickable: true,
              content: content
            }, content, () => { // 클릭
              // 오버레이 표출
              let _this = this
              this.requestMapData({ 'type': 'structureInfo', 'no': data.array[i].no }).then(data2 => {
                // console.log('structureInfo:', data2)
                let content = '<div class="structureinfo clearfix">' +
                  `<a class="title-bar" href="${this.$router.resolve({path: 'map', query: { no: 'b' + data.array[i].no }}).href}">${data.array[i].name}</a>`

                content += `<div class="layout"><div class="img-wrap flex shrink"><a href="${this.$router.resolve({path: 'map', query: { no: 'b' + data.array[i].no }}).href}">${(data2.array.imgurl !== '') ? "<img src='" + data2.array.imgurl + "' style='width: 100%; height: auto;'>" : '<div class="no-img">이미지준비중</div>'}</a></div>
                            <div class="addr flex grow"><span>${data2.array.roadaddr}</span><span class="jibun">${data2.array.addr}</span></div></div>
                <div class="info-area">`
                if (data2.array.tel.length > 0) {
                  content += `<div class="tel_area">`
                  data2.array.tel.forEach(function (value) {
                    // console.log(value)
                    content += `<a href="tel:${value}"><span class="tel">${value}</span></a>`
                  })
                  content += `</div>`
                }
                if (data2.array.memo.length > 0) {
                  content += `<div><span class="memo"><p>${data2.array.memo}</p></span></div>`
                }
                if (data2.array.tags.length > 0) {
                  content += `<div class="tag_area clearfix">`
                  data2.array.tags.forEach(function (value) {
                    content += `<span class="tag ml-1 ${_this.getStructureTagColor(value)}">#${_this.getStructureTagText(value)}</span>`
                  })
                  content += `</div>`
                }
                content +=
                  '</div>' +
                  '</div>' +
                  '<div class="after"></div>'

                this.mapView.structureMarker.contentNode.innerHTML = content
                this.mapView.structureMarker.overlay.setPosition(this.$refs.kakaomap.newLatLng(data.array[i].lat, data.array[i].lng))
                this.mapView.structureMarker.overlay.setMap(this.mapObject)
              })
              // 리스트 업데이트
              // 마커 리스트 업데이트
              this.mapData.filterState.viewType = 'tab-1'
              this.mapData.filterState.target.selected = true
              if (this.mapData.filterState.target.selected &&
                (this.mapData.filterState.target.lat !== data.array[i].lat ||
                  this.mapData.filterState.target.lng !== data.array[i].lng)) {
                // 중앙 이동
                this.setMapCenter(data.array[i].lat, data.array[i].lng, 'markerPoint', true)
              } else {
                this.requestItemList()
              }
              this.mapData.filterState.target.lat = data.array[i].lat
              this.mapData.filterState.target.lng = data.array[i].lng

              this.mapData.filterState.target.type = 'point'
              this.mapData.filterState.target.no = data.array[i].no
              this.mapData.filterState.target.totCount = 0
              this.mapData.filterState.target.listCount = 0
              this.requestItemList()
              // 리스트 오픈
              this.$refs.itemlist.setActiveMap(false)

              this.setMapCenter(data.array[i].lat, data.array[i].lng, 'PointMarker', true)
            }, () => { // 오버
              overlay.setZIndex(10)
            }, () => { // 아웃
              overlay.setZIndex(4)
            })
          }
        })
      } else {
        this.$refs.kakaomap.removeCustomOverlay('Point')
      }
    },
    /* 리스트 노출 */
    requestItemList () {
      if (this.mapData.itemListOverUpdateCancel) {
        this.mapData.itemListOverUpdateCancel = false
        return
      }
      this.mapData.filterState.listCount = 0
      this.mapData.filterState.target.listCount = 0
      this.requestMapData({ 'type': 'requestItemList', 'level': this.level, 'bounds': this.mapObject.getBounds(), 'window': {'w': document.getElementById('map_view').offsetWidth, 'h': document.getElementById('map_view').offsetHeight} }).then(data => {
        // console.log('data:', data)
        document.getElementById('list_scroll_area').scrollTop = 0 // 스크롤 맨위로
        if (data.array && data.array.length > 0) {
          this.mapData.filterState.listCount = this.mapData.filterState.listCount + data.array.length
          this.mapData.filterState.target.listCount = this.mapData.filterState.target.listCount + data.array.length
        }
        if (this.mapData.filterState.target.selected) {
          this.mapData.filterState.target.totCount = data.totcount
        }
        this.mapData.itemListData = data.array
      })
    },
    /* 지하철 노출 */
    printSubwayMarker () {
      if (this.level <= 6) {
        this.$refs.kakaomap.removeCustomOverlay('SW8')
        // const _this = this
        this.mapView.places.search.categorySearch('SW8', (places, status, pagination) => {
          if (this.$refs.kakaomap.getMaps().services.Status.OK) {
            for (let i = 0; i < places.length; i++) {
              // 마커를 생성하고 지도에 표시합니다
              let content = document.createElement('div')
              content.className = 'map-overlay-subway'
              content.innerHTML = '<div class="map-overlay-subway"><div><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px"\n' +
                '       height="32px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve" class="svg-mapicon-subway">\n' +
                '      <circle class="color-1" cx="16" cy="16" r="15.1"/>\n' +
                '      <path class="color-2" d="M14.5,8.6H16h1.5c0.3,0,0.5-0.2,0.5-0.5V7.3c0-0.3-0.2-0.5-0.5-0.5H16h-1.5c-0.3,0-0.5,0.2-0.5,0.5v0.8C14.1,8.4,14.3,8.6,14.5,8.6z"/>\n' +
                '      <path class="color-2" d="M21.1,12.6v-1.9c0-0.8-0.5-1.5-1.5-1.5H16h-3.6c-1,0-1.5,0.7-1.5,1.5v1.9c0,0.9,0.7,1.5,1.5,1.5H16h3.6C20.4,14.1,21.1,13.5,21.1,12.6z"/>\n' +
                '      <path class="color-2" d="M12.2,18.4c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3C13.6,19,13,18.4,12.2,18.4z"/>\n' +
                '      <path class="color-2" d="M16,31.5c-8.5,0-15.5-7-15.5-15.5S7.5,0.5,16,0.5s15.5,7,15.5,15.5S24.5,31.5,16,31.5z M21.6,28.3h3.2l-3.6-5.4c1.1-0.5,2-1.7,2-3.1V9.1c0-0.9-0.4-1.7-1-2.4c-0.7-0.7-1.5-1-2.5-1h-1.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.7-0.6-1.3-1.3-1.3h0c-0.4,0-0.7,0.1-0.9,0.4C16.1,4.1,16,4.2,16,4.3c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.3-0.6-0.4-0.9-0.4h0c-0.7,0-1.3,0.6-1.3,1.3c0,0.2,0.1,0.5,0.2,0.6h-1.4c-1,0-1.8,0.4-2.5,1c-0.6,0.6-1,1.5-1,2.4v10.7c0,1.5,0.9,2.6,2,3.1l-3.6,5.4h3.2l2.5-3.6h6.3L21.6,28.3z"/>\n' +
                '      <path class="color-3" d="M16,1c8.3,0,15,6.7,15,15c0,4.8-2.3,9.2-5.9,11.9l-0.4-0.6l-2.8-4.2c1.1-0.7,1.8-2,1.8-3.3V9.1c0-1-0.4-2-1.1-2.7c-0.8-0.8-1.8-1.2-2.9-1.2h-0.8c0,0,0-0.1,0-0.1c0-1-0.8-1.8-1.8-1.8c-0.4,0-0.8,0.1-1.1,0.4c-0.3-0.2-0.7-0.4-1.1-0.4l0,0l0,0v0c-1,0-1.8,0.8-1.8,1.8c0,0,0,0.1,0,0.1h-0.8c-1.1,0-2.1,0.4-2.9,1.2C8.7,7.1,8.3,8.1,8.3,9.1v10.7c0,1.3,0.7,2.6,1.8,3.3l-2.8,4.2l-0.4,0.6C3.3,25.2,1,20.8,1,16C1,7.7,7.7,1,16,1 M18.9,25.2l2.2,3.2l0.3,0.4h0.5h1.9C21.5,30.2,18.8,31,16,31s-5.5-0.8-7.8-2.2h1.9h0.5l0.3-0.4l2.2-3.2H16H18.9 M16,0C7.2,0,0,7.2,0,16c0,8.8,7.2,16,16,16c8.8,0,16-7.2,16-16C32,7.2,24.8,0,16,0L16,0z M17.1,5.8c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8c0,0,0,0,0,0c0,0,0,0,0,0c0.5,0,0.8,0.4,0.8,0.8C17.9,5.5,17.6,5.8,17.1,5.8L17.1,5.8z M14.9,4.2C14.9,4.2,14.9,4.2,14.9,4.2c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8C14.1,4.5,14.4,4.2,14.9,4.2C14.9,4.2,14.9,4.2,14.9,4.2L14.9,4.2z M12.3,6.2H16h3.7c0,0,0,0,0,0c1.7,0,3,1.4,3,2.9v10.7c0,1.5-1.1,2.7-2.3,2.9l3.5,5.2h-2l-2.5-3.6H16h-3.4l-2.5,3.6h-2l3.5-5.2c-1.2-0.2-2.3-1.4-2.3-2.9V9.1C9.3,7.5,10.6,6.2,12.3,6.2C12.3,6.2,12.3,6.2,12.3,6.2L12.3,6.2z"/>\n' +
                '      <path class="color-2" d="M21.1,19.7c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3C20.5,21.1,21,20.5,21.1,19.7z"/>\n' +
                '</svg></div><div class="info-text">' + places[i].place_name + '</div></div>'
              let position = this.$refs.kakaomap.newLatLng(places[i].y, places[i].x)

              // 지하철 정보 삽입
              // this.requestMapData({'type': 'addSubway', 'name': places[i].place_name, 'lat': places[i].y, 'lng': places[i].x})
              //
              this.$refs.kakaomap.addCustomOverlay('SW8', { // let overlay =
                position: position,
                clickable: true,
                content: content
              }, content, () => {
                // 지하철 오버레이 클릭
                // this.mapObject.setCenter(position)
                // this.mapObject.setLevel(4)
                // 마커 반경해제
                this.selectBoundsPolygon.setPath(null)
                this.overBoundsCircle.setMap(null)
                // 클릭
                this.selectBoundsCircle.setRadius(this.config.subwayRadius, this.config.subwayRadius)
                this.selectBoundsCircle.setPosition(position)
                this.selectBoundsCircle.setMap(this.mapObject)
                // 리스트 갱신
                // console.log(`lat: ${places[i].y} / lng: ${places[i].x} / ${Utile.LatitudeInDifference(500)} / ${Utile.LongitudeInDifference(places[i].y, 500)} `)
                // 마커 리스트 업데이트
                this.mapData.filterState.target.selected = true
                this.mapData.filterState.target.type = 'subway'
                this.mapData.filterState.target.minLat = (places[i].y * 1) - Utile.LatitudeInDifference(this.config.subwayRadius)
                this.mapData.filterState.target.maxLat = (places[i].y * 1) + Utile.LatitudeInDifference(this.config.subwayRadius)
                this.mapData.filterState.target.minLng = (places[i].x * 1) - Utile.LongitudeInDifference(places[i].y, this.config.subwayRadius)
                this.mapData.filterState.target.maxLng = (places[i].x * 1) + Utile.LongitudeInDifference(places[i].y, this.config.subwayRadius)
                this.mapData.filterState.target.totCount = 0
                this.mapData.filterState.target.listCount = 0
                this.requestItemList()
                // 리스트 오픈
                this.$refs.itemlist.setActiveMap(false)

                this.setMapCenter(places[i].y, places[i].x, 'markerSubway', true)
              }, () => { // 오버
                this.overBoundsCircle.setRadius(this.config.subwayRadius, this.config.subwayRadius)
                this.overBoundsCircle.setPosition(position)
                this.overBoundsCircle.setMap(this.mapObject)
              }, () => { // 아웃
                this.overBoundsCircle.setMap(null)
              })
            }
            if (pagination.hasNextPage) {
              // 있으면 다음 페이지를 검색한다.
              pagination.nextPage()
            }
          }
        }, {useMapBounds: true})
      } else {
        this.$refs.kakaomap.removeCustomOverlay('SW8')
      }
    },
    /* 장소 카테고리  */
    setPlaceCategory (op) {
      if (op === 'SC4' && this.level > 5) {
        EventBus.$emit('alert', '지도축적 250m 배율부터 사용 가능합니다. 좀 더 확대 해주시기 바랍니다.')
        return
      } else if (op !== 'SC4' && this.level > 4) {
        EventBus.$emit('alert', '지도축적 100m 배율부터 사용 가능합니다. 좀 더 확대 해주시기 바랍니다.')
        return
      }
      this.mapView.places.select === op ? this.mapView.places.select = '' : this.mapView.places.select = op
      if (this.mapView.places.select === op) {
        // 검색
        this.printPlaceCategoryMarker()
      } else {
        this.removePlaceCategoryMarker()
      }
    },
    printPlaceCategoryMarker () {
      this.removePlaceCategoryMarker()
      const cetegoryOrder = { 'SC4': 0, 'CE7': 1, 'CS2': 2, 'PK6': 3, 'MT1': 4 }
      let imgSize = { x: 26, y: 28 }
      let imgOptions = {
        spriteSize: this.$refs.kakaomap.newSize(280, 28), // 스프라이트 이미지의 크기
        spriteOrigin: this.$refs.kakaomap.newPoint((cetegoryOrder[this.mapView.places.select] * 28), 0), // 스프라이트 이미지 중 사용할 영역의 좌상단 좌표
        offset: this.$refs.kakaomap.newPoint(12, 28) // 마커 좌표에 일치시킬 이미지 내에서의 좌표
      }
      const _this = this
      this.mapView.places.search.categorySearch(this.mapView.places.select, (places, status, pagination) => {
        if (this.$refs.kakaomap.getMaps().services.Status.OK) {
          // console.log('카테고리 검색(' + this.mapView.places.select + '):' + places.length + '건 ')
          for (let i = 0; i < places.length; i++) {
            // 마커를 생성하고 지도에 표시합니다
            let marker = this.$refs.kakaomap.addMarker(this.mapView.places.select, {lat: places[i].y, lng: places[i].x}, `${Utile.getStaticUrl()}/map/mapCetegoryIcon.svg`, imgSize, imgOptions) // name, loc, imgurl, imgsize, options
            // 마커와 검색결과 항목을 클릭 했을 때
            // 장소정보를 표출하도록 클릭 이벤트를 등록합니다
            this.$refs.kakaomap.addListener(marker, 'click', function () {
              _this.displayPlaceInfo(places[i])
            })
          }
          if (pagination.hasNextPage) {
            // 있으면 다음 페이지를 검색한다.
            pagination.nextPage()
          }
        }
      }, {useMapBounds: true})
    },
    removePlaceCategoryMarker () {
      if (this.mapView.places.overlay != null) {
        this.mapView.places.overlay.setMap(null)
      }
      const cetegoryList = [ 'SC4', 'CE7', 'CS2', 'PK6', 'MT1' ]
      cetegoryList.forEach((item) => {
        this.$refs.kakaomap.removeMarker(item)
      })
    },
    displayPlaceInfo (place) {
      var content = '<div class="placeinfo">' +
        '   <a class="title-bar" href="' + place.place_url + '" target="_blank" title="' + place.place_name + '">' + place.place_name + '</a>'

      if (place.road_address_name) {
        content += '    <span title="' + place.road_address_name + '">' + place.road_address_name + '</span>' +
          '  <span class="jibun" title="' + place.address_name + '">(지번 : ' + place.address_name + ')</span>'
      } else {
        content += '    <span title="' + place.address_name + '">' + place.address_name + '</span>'
      }

      content += '    <span class="tel">' + place.phone + '</span>' +
        '</div>' +
        '<div class="after"></div>'

      this.mapView.places.contentNode.innerHTML = content
      this.mapView.places.overlay.setPosition(this.$refs.kakaomap.newLatLng(place.y, place.x))
      this.mapView.places.overlay.setMap(this.mapObject)
    },
    /* 선 거리 재기 */
    btnLineDistance () {
      // 클릭으로 그려진 선을 지도에서 제거하는 함수입니다
      let deleteClickLine = () => {
        if (this.mapView.lineDistance.clickLine) {
          this.mapView.lineDistance.clickLine.setMap(null)
          this.mapView.lineDistance.clickLine = null
        }
      }
      // 마우스 드래그로 그려지고 있는 선의 총거리 정보를 표시하거
      // 마우스 오른쪽 클릭으로 선 그리가 종료됐을 때 선의 정보를 표시하는 커스텀 오버레이를 생성하고 지도에 표시하는 함수입니다
      let showDistance = (content, position) => {
        if (this.mapView.lineDistance.distanceOverlay) { // 커스텀오버레이가 생성된 상태이면
          // 커스텀 오버레이의 위치와 표시할 내용을 설정합니다
          this.mapView.lineDistance.distanceOverlay.setPosition(position)
          this.mapView.lineDistance.distanceOverlay.setContent(content)
        } else { // 커스텀 오버레이가 생성되지 않은 상태이면
          // 커스텀 오버레이를 생성하고 지도에 표시합니다
          this.mapView.lineDistance.distanceOverlay = this.$refs.kakaomap.newCustomOverlay({
            map: this.mapObject, // 커스텀오버레이를 표시할 지도입니다
            content: content, // 커스텀오버레이에 표시할 내용입니다
            position: position, // 커스텀오버레이를 표시할 위치입니다.
            xAnchor: 0,
            yAnchor: 0,
            zIndex: 3
          })
        }
      }
      // 그려지고 있는 선의 총거리 정보와
      // 선 그리가 종료됐을 때 선의 정보를 표시하는 커스텀 오버레이를 삭제하는 함수입니다
      let deleteDistnce = () => {
        if (this.mapView.lineDistance.distanceOverlay) {
          this.mapView.lineDistance.distanceOverlay.setMap(null)
          this.mapView.lineDistance.distanceOverlay = null
        }
      }
      // 선이 그려지고 있는 상태일 때 지도를 클릭하면 호출하여
      // 클릭 지점에 대한 정보 (동그라미와 클릭 지점까지의 총거리)를 표출하는 함수입니다
      let displayCircleDot = (position, distance) => {
        // 클릭 지점을 표시할 빨간 동그라미 커스텀오버레이를 생성합니다
        var circleOverlay = this.$refs.kakaomap.newCustomOverlay({
          content: '<span class="dot"></span>',
          position: position,
          zIndex: 1
        })
        // 지도에 표시합니다
        circleOverlay.setMap(this.mapObject)
        if (distance > 0) {
          // 클릭한 지점까지의 그려진 선의 총 거리를 표시할 커스텀 오버레이를 생성합니다
          var distanceOverlay = this.$refs.kakaomap.newCustomOverlay({
            content: '<div class="dotOverlay">거리 <span class="number">' + distance + '</span>m</div>',
            position: position,
            yAnchor: 1,
            zIndex: 2
          })
          // 지도에 표시합니다
          distanceOverlay.setMap(this.mapObject)
        }
        // 배열에 추가합니다
        this.mapView.lineDistance.dots.push({circle: circleOverlay, distance: distanceOverlay})
      }
      // 클릭 지점에 대한 정보 (동그라미와 클릭 지점까지의 총거리)를 지도에서 모두 제거하는 함수입니다
      let deleteCircleDot = () => {
        var i
        for (i = 0; i < this.mapView.lineDistance.dots.length; i++) {
          if (this.mapView.lineDistance.dots[i].circle) {
            this.mapView.lineDistance.dots[i].circle.setMap(null)
          }
          if (this.mapView.lineDistance.dots[i].distance) {
            this.mapView.lineDistance.dots[i].distance.setMap(null)
          }
        }
        this.mapView.lineDistance.dots = []
      }
      // 마우스 우클릭 하여 선 그리기가 종료됐을 때 호출하여
      // 그려진 선의 총거리 정보와 거리에 대한 도보, 자전거 시간을 계산하여
      // HTML Content를 만들어 리턴하는 함수입니다
      let getTimeHTML = (distance) => {
        // 도보의 시속은 평균 4km/h 이고 도보의 분속은 67m/min입니다
        let walkkTime = distance / 67 | 0
        let walkHour = ''
        let walkMin = ''
        // 계산한 도보 시간이 60분 보다 크면 시간으로 표시합니다
        if (walkkTime > 60) {
          walkHour = '<span class="number">' + Math.floor(walkkTime / 60) + '</span>시간 '
        }
        walkMin = '<span class="number">' + walkkTime % 60 + '</span>분'

        // 자전거의 평균 시속은 16km/h 이고 이것을 기준으로 자전거의 분속은 267m/min입니다
        let bycicleTime = distance / 227 | 0
        let bycicleHour = ''
        let bycicleMin = ''
        // 계산한 자전거 시간이 60분 보다 크면 시간으로 표출합니다
        if (bycicleTime > 60) {
          bycicleHour = '<span class="number">' + Math.floor(bycicleTime / 60) + '</span>시간 '
        }
        bycicleMin = '<span class="number">' + bycicleTime % 60 + '</span>분'

        // 거리와 도보 시간, 자전거 시간을 가지고 HTML Content를 만들어 리턴합니다
        let content = '<ul class="dotOverlay distanceInfo">'
        content += '    <li>'
        content += '        <span class="label">총거리</span><span class="number">' + distance + '</span>m'
        content += '    </li>'
        content += '    <li>'
        content += '        <span class="label">도보</span>' + walkHour + walkMin
        content += '    </li>'
        content += '    <li>'
        content += '        <span class="label">자전거</span>' + bycicleHour + bycicleMin
        content += '    </li>'
        content += '</ul>'

        return content
      }
      if (this.mapView.lineDistance.clickHandler === null) {
        this.mapView.lineDistance.clickHandler = (mouseEvent) => {
          // 마우스로 클릭한 위치입니다
          var clickPosition = mouseEvent.latLng
          // 지도 클릭이벤트가 발생했는데 선을 그리고있는 상태가 아니면
          if (!this.mapView.lineDistance.drawingFlag) {
            // 상태를 true로, 선이 그리고있는 상태로 변경합니다
            this.mapView.lineDistance.drawingFlag = true
            // 지도 위에 선이 표시되고 있다면 지도에서 제거합니다
            deleteClickLine()
            // 지도 위에 커스텀오버레이가 표시되고 있다면 지도에서 제거합니다
            deleteDistnce()
            // 지도 위에 선을 그리기 위해 클릭한 지점과 해당 지점의 거리정보가 표시되고 있다면 지도에서 제거합니다
            deleteCircleDot()
            // 클릭한 위치를 기준으로 선을 생성하고 지도위에 표시합니다
            this.mapView.lineDistance.clickLine = this.$refs.kakaomap.newPolyline({
              map: this.mapObject, // 선을 표시할 지도입니다
              path: [clickPosition], // 선을 구성하는 좌표 배열입니다 클릭한 위치를 넣어줍니다
              strokeWeight: 3, // 선의 두께입니다
              strokeColor: '#db4040', // 선의 색깔입니다
              strokeOpacity: 1, // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
              strokeStyle: 'solid' // 선의 스타일입니다
            })
            // 선이 그려지고 있을 때 마우스 움직임에 따라 선이 그려질 위치를 표시할 선을 생성합니다
            this.mapView.lineDistance.moveLine = this.$refs.kakaomap.newPolyline({
              strokeWeight: 3, // 선의 두께입니다
              strokeColor: '#db4040', // 선의 색깔입니다
              strokeOpacity: 0.5, // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
              strokeStyle: 'solid' // 선의 스타일입니다
            })
            // 클릭한 지점에 대한 정보를 지도에 표시합니다
            displayCircleDot(clickPosition, 0)
          } else { // 선이 그려지고 있는 상태이면
            // 그려지고 있는 선의 좌표 배열을 얻어옵니다
            var path = this.mapView.lineDistance.clickLine.getPath()
            // 좌표 배열에 클릭한 위치를 추가합니다
            path.push(clickPosition)

            // 다시 선에 좌표 배열을 설정하여 클릭 위치까지 선을 그리도록 설정합니다
            this.mapView.lineDistance.clickLine.setPath(path)
            var distance = Math.round(this.mapView.lineDistance.clickLine.getLength())
            displayCircleDot(clickPosition, distance)
          }
        }
        this.mapView.lineDistance.mousemoveHandler = (mouseEvent) => {
          // 지도 마우스무브 이벤트가 발생했는데 선을 그리고있는 상태이면
          if (this.mapView.lineDistance.drawingFlag) {
            // 마우스 커서의 현재 위치를 얻어옵니다
            var mousePosition = mouseEvent.latLng
            // 마우스 클릭으로 그려진 선의 좌표 배열을 얻어옵니다
            var path = this.mapView.lineDistance.clickLine.getPath()
            // 마우스 클릭으로 그려진 마지막 좌표와 마우스 커서 위치의 좌표로 선을 표시합니다
            var movepath = [path[path.length - 1], mousePosition]
            this.mapView.lineDistance.moveLine.setPath(movepath)
            this.mapView.lineDistance.moveLine.setMap(this.mapObject)
            let distance = Math.round(this.mapView.lineDistance.clickLine.getLength() + this.mapView.lineDistance.moveLine.getLength()) // 선의 총 거리를 계산합니다
            let content = '<div class="dotOverlay distanceInfo">총거리 <span class="number">' + distance + '</span>m</div>' // 커스텀오버레이에 추가될 내용입니다

            // 거리정보를 지도에 표시합니다
            showDistance(content, mousePosition)
          }
        }
        this.mapView.lineDistance.rightclickHandler = (mouseEvent) => {
          // 지도 오른쪽 클릭 이벤트가 발생했는데 선을 그리고있는 상태이면
          if (this.mapView.lineDistance.drawingFlag) {
            // 마우스무브로 그려진 선은 지도에서 제거합니다
            this.mapView.lineDistance.moveLine.setMap(null)
            this.mapView.lineDistance.moveLine = null
            // 마우스 클릭으로 그린 선의 좌표 배열을 얻어옵니다
            var path = this.mapView.lineDistance.clickLine.getPath()
            // 선을 구성하는 좌표의 개수가 2개 이상이면
            if (path.length > 1) {
              // 마지막 클릭 지점에 대한 거리 정보 커스텀 오버레이를 지웁니다
              if (this.mapView.lineDistance.dots[this.mapView.lineDistance.dots.length - 1].distance) {
                this.mapView.lineDistance.dots[this.mapView.lineDistance.dots.length - 1].distance.setMap(null)
                this.mapView.lineDistance.dots[this.mapView.lineDistance.dots.length - 1].distance = null
              }
              let distance = Math.round(this.mapView.lineDistance.clickLine.getLength()) // 선의 총 거리를 계산합니다
              let content = getTimeHTML(distance) // 커스텀오버레이에 추가될 내용입니다
              // 그려진 선의 거리정보를 지도에 표시합니다
              showDistance(content, path[path.length - 1])
            } else {
              // 선을 구성하는 좌표의 개수가 1개 이하이면
              // 지도에 표시되고 있는 선과 정보들을 지도에서 제거합니다.
              deleteClickLine()
              deleteCircleDot()
              deleteDistnce()
            }
            // 상태를 false로, 그리지 않고 있는 상태로 변경합니다
            this.mapView.lineDistance.drawingFlag = false
          }
        }
      }
      if (this.mapView.lineDistance.selected) {
        this.mapView.lineDistance.selected = false
        this.mapView.lineDistance.drawingFlag = false
        deleteClickLine()
        deleteDistnce()
        deleteCircleDot()
        this.$refs.kakaomap.removeListener(this.mapObject, 'click', this.mapView.lineDistance.clickHandler)
        this.$refs.kakaomap.removeListener(this.mapObject, 'mousemove', this.mapView.lineDistance.mousemoveHandler)
        this.$refs.kakaomap.removeListener(this.mapObject, 'rightclick', this.mapView.lineDistance.rightclickHandler)
      } else {
        this.mapView.lineDistance.selected = true
        this.$refs.kakaomap.addListener(this.mapObject, 'click', this.mapView.lineDistance.clickHandler)
        this.$refs.kakaomap.addListener(this.mapObject, 'mousemove', this.mapView.lineDistance.mousemoveHandler)
        this.$refs.kakaomap.addListener(this.mapObject, 'rightclick', this.mapView.lineDistance.rightclickHandler)
      }
    },
    /* 맵 상태변경 업데이트 */
    updateMap (type = 'null') {
      // console.log(`update(${type})`)
      if (!this.isInit || (this.prevUpdateType === 'login' && this.prevUpdateType === type) || (this.prevUpdateType === 'logout' && this.prevUpdateType === type)) return
      this.prevUpdateType = type

      // console.log(`update - run`)

      const _level = this.level
      // 장소 카테고리
      if (this.mapView.places.select === 'SC4' && _level > 5) {
        this.removePlaceCategoryMarker()
        this.mapView.places.select = ''
      } else if (this.mapView.places.select !== 'SC4' && _level > 4) {
        this.removePlaceCategoryMarker()
        this.mapView.places.select = ''
      }
      if (this.mapView.places.select !== '') {
        this.printPlaceCategoryMarker()
      }
      // 건물정보 오버레이 제거
      if (_level > 1) {
        if (this.mapView.structureMarker.overlay !== null) {
          this.mapView.structureMarker.overlay.setMap(null)
        }
      }
      this.overBoundsPolygon.setMap(null)
      // this.selectBoundsPolygon.setMap(null)
      this.overBoundsCircle.setMap(null)
      // this.selectBoundsCircle.setMap(null)
      // 셀렉트 초기화
      // this.mapData.filterState.target.selected = false
      // 지하철 표시
      this.printSubwayMarker()
      // 리스트 초기화 업데이트
      this.mapData.filterState.totCount = 0
      this.requestItemList() // 리스트
      // 업데이트
      this.requestSIGMarker() // 시군구
      this.requestEMDMarker() // 동
      this.requestRangeMarker() // 범위마커
      this.requestPointMarker() // 정확한 마커
      // 현 위치정보
      this.loadAddrInfo()
      /*
      1. /20m/ 2레벨 이상 상세 건물뷰
      2. /30m/ ''
      3. /50m/ ''
      4. /100m/ <클러스터 범위
      5. /250m/ <동면리(클릭시 4)
      6. /500m/ >시군구(클릭시 5), <지하철(클릭시 4)
      7. /1km/ >시군구(클릭시 5)
      */
      // console.log('레벨:' + _level + ' / ' + this.mapObject.getCenter().toString() + ' / ' + this.mapObject.getBounds().toString())
    },
    /* 맵 초기설정 */
    initMap () {
      EventBus.$emit('resetMapMinLevel')

      this.overBoundsCircle = this.$refs.kakaomap.newCircle({
        strokeWeight: 2, // 선의 두께입니다
        strokeColor: '#ff4d63', // 선의 색깔입니다
        strokeOpacity: 0.4, // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
        strokeStyle: 'solid', // 선의 스타일입니다
        fillColor: '#ff4d63', // 채우기 색깔입니다
        fillOpacity: 0.1, // 채우기 불투명도입니다
        zIndex: 1
      })
      this.selectBoundsCircle = this.$refs.kakaomap.newCircle({
        strokeWeight: 2, // 선의 두께입니다
        strokeColor: '#0056e6', // 선의 색깔입니다
        strokeOpacity: 0.4, // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
        strokeStyle: 'solid', // 선의 스타일입니다
        fillColor: '#0056e6', // 채우기 색깔입니다
        fillOpacity: 0.1, // 채우기 불투명도입니다
        zIndex: 2
      })
      this.overBoundsPolygon = this.$refs.kakaomap.newPolygon({
        strokeWeight: 2, // 선의 두께입니다
        strokeColor: '#ff4d63', // 선의 색깔입니다
        strokeOpacity: 0.4, // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
        strokeStyle: 'solid', // 선의 스타일입니다
        fillColor: '#ff4d63', // 채우기 색깔입니다
        fillOpacity: 0.1, // 채우기 불투명도입니다
        zIndex: 1
      })
      this.selectBoundsPolygon = this.$refs.kakaomap.newPolygon({
        strokeWeight: 2, // 선의 두께입니다
        strokeColor: '#0056e6', // 선의 색깔입니다
        strokeOpacity: 0.4, // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
        strokeStyle: 'solid', // 선의 스타일입니다
        fillColor: '#0056e6', // 채우기 색깔입니다
        fillOpacity: 0.1, // 채우기 불투명도입니다
        zIndex: 2
      })
      // 장소 카테고리 오버레이
      this.mapView.places.search = this.$refs.kakaomap.newPlaces()
      this.mapView.places.overlay = this.$refs.kakaomap.newCustomOverlay({zIndex: 10})
      this.mapView.places.contentNode = document.createElement('div')
      this.mapView.places.contentNode.className = 'placeinfo-wrap'
      this.$refs.kakaomap.addEventHandle(this.mapView.places.contentNode, 'mousedown', this.$refs.kakaomap.getMaps().event.preventMap)
      this.$refs.kakaomap.addEventHandle(this.mapView.places.contentNode, 'touchstart', this.$refs.kakaomap.getMaps().event.preventMap)
      this.mapView.places.overlay.setContent(this.mapView.places.contentNode)
      // 건물 정보 오버레이
      this.mapView.structureMarker.overlay = this.$refs.kakaomap.newCustomOverlay({zIndex: 10})
      this.mapView.structureMarker.contentNode = document.createElement('div')
      this.mapView.structureMarker.contentNode.className = 'structureinfo-wrap'
      this.$refs.kakaomap.addEventHandle(this.mapView.structureMarker.contentNode, 'mousedown', this.$refs.kakaomap.getMaps().event.preventMap)
      this.$refs.kakaomap.addEventHandle(this.mapView.structureMarker.contentNode, 'touchstart', this.$refs.kakaomap.getMaps().event.preventMap)
      this.mapView.structureMarker.overlay.setContent(this.mapView.structureMarker.contentNode)
      // 로딩완료
      this.isInit = true
      // 업데이트
      this.updateMap('init')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Map.vue